var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"train-box"},[(_vm.currentTab=='accessMag')?_c('access-mag'):_vm._e(),(_vm.currentTab=='videoMonitor')?_c('video-monitor'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }